import { render, staticRenderFns } from "./CreateSchoolWizard.vue?vue&type=template&id=8a3b54aa&"
import script from "./CreateSchoolWizard.vue?vue&type=script&lang=js&"
export * from "./CreateSchoolWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a3b54aa')) {
      api.createRecord('8a3b54aa', component.options)
    } else {
      api.reload('8a3b54aa', component.options)
    }
    module.hot.accept("./CreateSchoolWizard.vue?vue&type=template&id=8a3b54aa&", function () {
      api.rerender('8a3b54aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/CreateSchoolWizard.vue"
export default component.exports